import React, { useState, useEffect } from 'react';


const NotificationIndicator = ({ count = 0, type = 'default', position = 'top-right' }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (count > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [count]);

  const getTypeStyles = () => {
    switch (type) {
      case 'mood':
        return 'bg-accent text-accent-foreground';
      case 'communication':
        return 'bg-primary text-primary-foreground';
      case 'schedule':
        return 'bg-warning text-warning-foreground';
      default:
        return 'bg-primary text-primary-foreground';
    }
  };

  const getPositionStyles = () => {
    switch (position) {
      case 'top-right':
        return 'top-0 right-0 translate-x-1/2 -translate-y-1/2';
      case 'top-left':
        return 'top-0 left-0 -translate-x-1/2 -translate-y-1/2';
      default:
        return 'top-0 right-0 translate-x-1/2 -translate-y-1/2';
    }
  };

  if (!isVisible) return null;

  return (
    <span
      className={`
        absolute ${getPositionStyles()}
        flex items-center justify-center
        min-w-[20px] h-5 px-1.5 rounded-full
        text-xs font-medium font-caption
        ${getTypeStyles()}
        transition-therapeutic
        shadow-therapeutic-sm
      `}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default NotificationIndicator;